export default __webpack_public_path__ + "static/media/phone2framemobile.0c2cce51.svg";